import { throwError } from "@/lib/throwError";
import { get, post } from "@/services/axiosUitils";
import { ManageActiveRecordParams } from "@/utils/types/activeRecord";
import { mergeServiceDeskParams, mergeServiceDeskBody } from "@/lib/serviceDeskApiParams";

const basePath = "/dropdown/";

export type DropdownRequestOptions = {
  /** Do not send `is_servicedesk=true` on query params. */
  skipServiceDeskParams?: boolean;
};

class DropdownService {
  getDropdownData = async (
    name: string,
    params?: Record<string, unknown>,
    options?: DropdownRequestOptions
  ): Promise<any> => {
    if (!name) {
      throwError("Name is required", "DropdownService");
    }
    const skipServicedesk =
      options?.skipServiceDeskParams === true || name === "schema";
    const queryParams = skipServicedesk
      ? params ?? {}
      : mergeServiceDeskParams(params ?? {});
    return await get(`${basePath}${name}/`, {
      params: queryParams,
    });
  };

  manageActiveRecord = async (
    params: ManageActiveRecordParams
  ): Promise<any> => {
    if (!params.table) {
      throwError("Table is required", "DropdownService");
    }
    if (!params.pk) {
      throwError("Primary key (pk) is required", "DropdownService");
    }
    if (typeof params.is_active !== "boolean") {
      throwError("is_active must be a boolean", "DropdownService");
    }
    return await post(`${basePath}manage-active-record/`, mergeServiceDeskBody(params));
  };

  /**
   * Get Users for dropdown
   */
  getUsers = async (): Promise<any[]> => {
    const data = await get(`${basePath}user/`, {
      params: mergeServiceDeskParams({})
    });
    // Assuming the API returns a list or a results object
    if (Array.isArray(data)) {
      return data;
    } else if (data?.results && Array.isArray(data.results)) {
      return data.results;
    } else if (data?.data && Array.isArray(data.data)) {
      return data.data; // Some APIs wrap in 'data'
    }
    return [];
  };
}

export default new DropdownService();
